import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EIPDatePickerComponent } from 'eipdate-picker';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import * as moment from 'moment';
import { ProjectMasterService } from 'src/app/Service/projectmaster/projectmaster.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { DrawingScheduleAdherenceCalculationmodel } from 'src/app/ViewModel/Report.Model';
import { ReportService } from 'src/app/Service/Report/Report.service';
import { DataBindingDirective, RowClassArgs } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-Drawings_Adherence_report',
  templateUrl: './Drawings_Adherence_report.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./Drawings_Adherence_report.component.css']
})
export class DrawingsAdherenceComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public ScheduleStartDate;
  public ScheduleEndDate;
  ShowSearch: boolean = false;
  public projectId!: number;
  public groupId!: number;
  public dynamicField: FieldConfig[] = [];
  public stageList: IProjectElementDetailsOutput[] = [];
  public dwgList!: IProjectElementDetailsOutput[];
  public enableFilter = false;
  public cal_enableFilter = false;
  public from_Date!: string;
  public to_Date!: string;
  public stages: number | null | undefined;
  public drg_Type: string | undefined | null;
  public fromDate: any;
  public Datalist: any[] = [];
  public CalDatalist: DrawingScheduleAdherenceCalculationmodel[] = [];
  numElements: Map<string, string> = new Map<string, string>();
  public Project_Code!: string;
  public Trans_Type!: string;
  public GrdVisible = false;
  public structure: any[] = [];
  public discipline: any[] = [];
  public disciplineId: string | undefined | null;
  public structureId: string | undefined | null;
  public projectCode!: string;
  public Legend: any[] = [];
  @ViewChild('todatePicker') dateRange!: EIPDatePickerComponent;

  @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;
  projectElements: IProjectElementsOutput[] = [];
  elementsConfig: FieldConfig[] = [];

  public DrawingsAdherenceForm: FormGroup = new FormGroup({

    ScheduleStartDate: new FormControl(),
    ScheduleEndDate: new FormControl(),

  });

  constructor(private _projectService: ProjectMasterService, private _projInfoService: ProjectInfoService,
    private _commonService: CommonService, private dialog: MatDialog, private _notificationService: NotificationService,
    private ReportService: ReportService) {
    this.allData = this.allData.bind(this);
    this.fullData = this.fullData.bind(this);
  }

  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.projectCode = this._commonService.getProjectCode();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.getDropDownValue();
    this.CallLegend();
    this.getDynamicForm().then((res: any) => {
      this.finalView();
    });
  }

  toggleShowSearch() {
    this.ShowSearch = !this.ShowSearch;
  }

  async getDynamicForm() {
    this._projInfoService.getProjectElements({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      IsQueryForStaticElement: false
    }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;

        this.elementsConfig = res.filter(s => {
          return s.isMandatory == true;
        }).map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.ScheduleDocument,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
            value: new BehaviorSubject(null)
          };

          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();
        this.onCascadingAutocomplete_Change();
        this.copyElementDetailsFromSource();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach((data: any) => {
      if (!!data.child_de_id) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe(x => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

          if (_field.length > 0 && !!parentControlSelectedValue) {
            this._projInfoService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.ScheduleDocument,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                _field[0].values = res;
              } else {
                _field[0].values = [];
              }
            }, err => { });
          } else {
            _field[0].values = [];
          }
        })
      }
    })
  }

  private copyElementDetailsFromSource() {
    let sourceProjElementForm: FormGroup = this.dynamicForm.value;
    this.projectElements.filter(s => {
      return s.isNumbering == false
    }).forEach(x => {
      let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
      if (!!selectedValue) {
        let field: FieldConfig | undefined = this.elementsConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription);
        if (field && field.value) {
          field.value.next(selectedValue.dedId);
        }
      }
    })
  }

  async LoadSearchDetails(): Promise<any[]> {
    let resForm: FormGroup | undefined | null = this.dynamicForm.form;

    let FilterDetails: any[] = [];

    this.projectElements.map(async x => {
      let result: any;
      let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
      result = {
        dE_Id: x.elementId,
        dED_Id: selectedValue.dedId
      }
      FilterDetails.push(result);
    })

    return FilterDetails;
  }

  getDropDownValue() {

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Workflow Status'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.stageList = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'DWG / DOC'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.dwgList = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Discipline'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.discipline = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Structure / Package'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.structure = res;
    });
  }

  selectedDwg(value: any) {
    if (value.value != "-2") {
      this.drg_Type = value.additionalValues.additionalValues.dedId;
    } else {
      this.drg_Type = null;
    }
  }
  selectedProject(value: any) {
    this.Project_Code = value.additionalValues.additionalValues.project_Code;
  }

  getFromDateValue(date: any) {
    this.from_Date = date;
  }

  getToDateValue(date: any) {
    this.to_Date = date;
  }

  selectedStage(value: any) {
    if (value.value != "-2") {
      this.stages = value.additionalValues.additionalValues.dedId;
    } else {
      this.stages = null;
    }
  }

  getFormValue(controlName: string): any {
    return this.DrawingsAdherenceForm.get(controlName)?.value;
  }

  getStartDateValue(selectedText: any) {
    this.DrawingsAdherenceForm.get('ScheduleStartDate')?.setValue(selectedText);
  }

  getEndDateValue(selectedText: any) {
    this.DrawingsAdherenceForm.get('ScheduleEndDate')?.setValue(selectedText);
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  caltoggleFilter() {
    this.cal_enableFilter = !this.cal_enableFilter;
  }

  selectedDiscipline(value: any) {
    if (value.value != "-2") {
      this.disciplineId = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.disciplineId = null;
    }
  }

  selectedSturcture(value: any) {
    if (value.value != "-2") {
      this.structureId = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.structureId = null;
    }
  }
  public rowCallback(context: RowClassArgs) {
    if (context.dataItem.delay_Days < 0) { // change this condition as you need
      return {
        AdvanceRelease: true
      };
    } else if (context.dataItem.delay_Days > 0) {
      return {
        Delay: true
      };
    } else if (context.dataItem.delay_Days == 0) {
      return {
        ReleasedOnTime: true
      };

    } else
      return;

  }
  public rowClassCallback = (context: RowClassArgs): void | object => {

    switch (context.dataItem.Delay) {
      case -1:
        return {
          Col_AdvanceRelease: true
        };
      case 0:
        return {
          Col_ReleasedOnTime: true
        };
      case 1:
        return {
          Col_Delay: true
        };
    }
  }
  CallLegend() {
    this.Legend = [];
    let Delayed_Release: any = {
      Doc_Release: "Delayed Release",
      Delay: 1
    }
    let Advanced_Release: any = {
      Doc_Release: "Advanced Release",
      Delay: -1
    }
    let Released_On_time: any = {
      Doc_Release: "Released on time",
      Delay: 0
    }
    this.Legend.push(Delayed_Release);
    this.Legend.push(Advanced_Release);
    this.Legend.push(Released_On_time);
  }

  public allData(): ExcelExportData {
    let _data: any = this.Datalist;

    for (let index = 0; index < _data.length; index++) {
      _data[index].scheduled_On = this.getFormattedDate(_data[index].scheduled_On);
      _data[index].completed_On = this.getFormattedDate(_data[index].completed_On);
    }
    const result: ExcelExportData = {
      data: _data
    };
    return result;
  }

  public fullData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.CalDatalist
    };
    return result;
  }

  public getFormattedDate(date: moment.MomentInput) {
    if (date != null) {
      let res = (moment(date)).format('DD-MMM-yyyy');
      return res;
    }
    return null
  }

  finalView() {
    this.GrdVisible = false;

    this.LoadSearchDetails().then((res: any[]) => {
      let obj: any = {
        Project_Id: this.projectId,
        Dynamic_Id: res,
        From_Date: !!this.getFormValue('ScheduleStartDate') ? this.getFormValue('ScheduleStartDate') : null,
        To_Date: !!this.getFormValue('ScheduleEndDate') ? this.getFormValue('ScheduleEndDate') : null,
        Stages: this.stages,
        Proj_Code: this.projectCode
      }

      this.Datalist = [];
      this.CalDatalist = [];
      this.ReportService.GetDrawingScheduleAdherenceList(obj).subscribe((data: any) => {
        if (data) {
          this.Datalist = data.drawingScheduleAdherenceOutputModel;
          this.CalDatalist = data.drawingScheduleCalOutputtModel;
          if (this.Datalist && this.Datalist.length > 0)
            this.GrdVisible = true;
        } else {
          this.Datalist = [];
          //this._notificationService.showToast("No Records avilable.", "Warning");
        }
      });
    })
  }

  delayed_Filter() {
    if (this.GrdVisible == true) {
      this.dataBinding.skip = 0;

      this.LoadSearchDetails().then((res: any[]) => {
        let obj: any = {
          Project_Id: this.projectId,
          Dynamic_Id: res,
          From_Date: !!this.getFormValue('ScheduleStartDate') ? this.getFormValue('ScheduleStartDate') : null,
          To_Date: !!this.getFormValue('ScheduleEndDate') ? this.getFormValue('ScheduleEndDate') : null,
          Stages: this.stages,
          Proj_Code: this.projectCode
        }

        this.Datalist = [];
        this.ReportService.GetDrawingScheduleAdherenceList(obj).subscribe((data: any) => {
          if (data) {
            this.Datalist = data.drawingScheduleAdherenceOutputModel;
            this.Datalist = this.Datalist.filter(x => x.delay_Days > 0);
          } else {
            this.Datalist = [];
          }
        });
      });
    }
  }

  advanced_Filter() {
    if (this.GrdVisible == true) {
      this.dataBinding.skip = 0;

      this.LoadSearchDetails().then((res: any[]) => {
        let obj: any = {
          Project_Id: this.projectId,
          Dynamic_Id: res,
          From_Date: !!this.getFormValue('ScheduleStartDate') ? this.getFormValue('ScheduleStartDate') : null,
          To_Date: !!this.getFormValue('ScheduleEndDate') ? this.getFormValue('ScheduleEndDate') : null,
          Stages: this.stages,
          Proj_Code: this.projectCode
        }

        this.Datalist = [];
        this.ReportService.GetDrawingScheduleAdherenceList(obj).subscribe((data: any) => {
          if (data) {
            this.Datalist = data.drawingScheduleAdherenceOutputModel;
            this.Datalist = this.Datalist.filter(x => x.delay_Days < 0);
          } else {
            this.Datalist = [];
          }
        });
      })
    }
  }

  ontime_Filter() {
    if (this.GrdVisible == true) {
      this.dataBinding.skip = 0;

      this.LoadSearchDetails().then((res: any[]) => {
        let obj: any = {
          Project_Id: this.projectId,
          Dynamic_Id: res,
          From_Date: !!this.getFormValue('ScheduleStartDate') ? this.getFormValue('ScheduleStartDate') : null,
          To_Date: !!this.getFormValue('ScheduleEndDate') ? this.getFormValue('ScheduleEndDate') : null,
          Stages: this.stages,
          Proj_Code: this.projectCode
        }

        this.Datalist = [];
        this.ReportService.GetDrawingScheduleAdherenceList(obj).subscribe((data: any) => {
          if (data) {
            this.Datalist = data.drawingScheduleAdherenceOutputModel;
            this.Datalist = this.Datalist.filter(x => x.delay_Days == 0);
          } else {
            this.Datalist = [];
          }
        });
      })
    }
  }
}